<template>
	<div class="download-wrap">
		<div class="page-header">
			<span class="logo"><img src="../../assets/img/common/logo.png"/></span>
			<p class="sologan">一款真实的社交婚恋APP</p>
			<span class="download-btn"><a href="http://www.yushuiyuan.cn/download.html" target="_blank">下载</a></span>
			<span class="close" @click="close"><img src="../../assets/img/common/ic_text_del@2x.png"/></span>
		</div>
	</div>
</template>

<script>
	export default{
		name:"download-header",
		methods:{
			close(){
				this.$emit("close")
			},
		}
	}
</script>

<style scoped>
	.page-header{
		position: fixed;
		width: 100%;
		height: 3rem;
		background: rgba(0,0,0,.5);
		top: 0;
		left: 0;
		z-index: 999;
		padding: 0 0.5rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.page-header .logo,.page-header .logo img{
		height: 100%;
		display: block;
	}
	.page-header .sologan{
		flex: 1;
		font-size: 1rem;
		color: #fff;
		padding: 0 1rem;
		font-weight: bold;
	}
	.page-header .close img{
		height: 1.5rem;
		display: block;
	}
	.page-header .download-btn a{
		font-size: 0.8rem;
		padding: 0.1rem 0.5rem;
		margin-right: 0.5rem;
		color: #fff;
		border: 1px solid #fff;
		border-radius: 1rem;
		opacity: 0.7;
		text-decoration: none;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/DownloadHeader.vue